import { render, staticRenderFns } from "./RegistrationsCrud.vue?vue&type=template&id=1b5910a6&scoped=true"
import script from "./RegistrationsCrud.vue?vue&type=script&lang=js"
export * from "./RegistrationsCrud.vue?vue&type=script&lang=js"
import style0 from "./RegistrationsCrud.vue?vue&type=style&index=0&id=1b5910a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5910a6",
  null
  
)

export default component.exports